import React from "react";

const TentTopPath = (props) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="1564pt"
    height="982pt"
    viewBox="0 0 1564 982"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0,982) scale(0.1,-0.1)"
      fill="#ff0000"
      stroke="none"
    >
      <path d="M8175 8889 c-55 -3 -125 -11 -156 -18 l-56 -12 -7 -227 c-5 -125 -11
-315 -15 -422 -4 -107 -6 -196 -5 -198 1 -1 35 8 75 22 214 72 588 89 1225 56
299 -16 603 7 824 61 266 66 473 169 624 309 75 70 101 107 70 97 -167 -53
-337 -69 -566 -56 -263 16 -566 81 -958 204 -440 139 -790 200 -1055 184z" />
      <path d="M7726 7416 c-117 -59 -179 -159 -179 -286 0 -86 22 -145 73 -203 l32
-37 -53 -97 c-174 -326 -442 -732 -725 -1099 -224 -290 -399 -489 -708 -803
-457 -463 -921 -851 -1461 -1225 -783 -542 -1712 -1020 -2700 -1388 -243 -90
-739 -257 -979 -329 -60 -18 -105 -34 -100 -36 10 -2 287 -33 584 -63 240 -25
897 -85 1161 -106 l206 -16 149 75 c383 195 859 479 1224 733 833 577 1542
1244 2134 2009 545 703 938 1384 1247 2158 34 84 62 153 63 154 1 2 15 -3 30
-10 34 -15 33 -17 -30 -277 -194 -800 -462 -1535 -828 -2270 -478 -959 -1104
-1824 -1902 -2629 -35 -35 -62 -66 -61 -68 10 -9 1023 -45 1677 -59 l305 -7
34 109 c384 1238 667 2712 826 4299 28 289 52 569 60 705 3 52 8 112 11 133 5
34 8 37 40 37 19 0 37 -6 39 -12 2 -7 9 -83 15 -168 55 -806 180 -1799 340
-2715 129 -742 366 -1723 556 -2307 l26 -78 96 0 c265 0 1240 31 1654 52 l237
12 -172 176 c-463 474 -877 990 -1240 1546 -89 136 -217 342 -217 350 0 2 -11
21 -23 42 -124 197 -377 684 -502 967 -306 692 -498 1264 -670 2000 -14 61
-28 118 -31 127 -3 12 5 22 26 33 29 15 31 15 40 -7 5 -13 38 -95 73 -183 360
-899 952 -1841 1626 -2589 844 -935 1753 -1631 2954 -2261 l148 -77 262 21
c431 35 1073 94 1207 111 41 5 172 19 290 31 l215 23 -80 23 c-182 53 -788
257 -1025 346 -1248 466 -2304 1051 -3260 1806 -516 408 -1043 922 -1443 1408
-323 393 -671 908 -887 1309 l-43 81 37 48 c96 126 84 307 -27 418 -57 57
-116 80 -217 84 -74 3 -91 1 -134 -21z" />
      <path d="M903 1708 c11 -215 88 -380 251 -541 116 -115 247 -194 407 -248 130
-43 224 -59 357 -59 439 1 813 265 957 679 l24 66 0 -51 c5 -321 215 -649 514
-800 409 -208 859 -139 1181 180 128 126 236 317 277 486 l13 55 11 -86 c17
-119 33 -182 68 -269 113 -275 320 -473 595 -566 285 -97 583 -58 845 109 130
83 280 255 356 405 41 81 88 222 97 290 4 29 8 51 10 49 2 -2 11 -44 19 -93
49 -286 212 -541 440 -690 185 -120 326 -164 524 -164 125 0 204 13 324 54
345 118 614 450 666 821 9 66 10 64 36 -45 80 -333 329 -616 643 -730 362
-131 764 -35 1031 245 161 170 253 370 269 587 l8 98 -61 0 c-33 0 -298 -9
-590 -20 -291 -10 -683 -22 -870 -25 -187 -3 -376 -8 -420 -10 -44 -3 -485 -5
-980 -5 -935 0 -1524 9 -2220 35 -71 3 -258 10 -415 15 -257 10 -728 32 -965
45 -305 18 -606 37 -775 50 -107 8 -316 24 -465 35 -503 38 -1018 83 -1645
145 -140 13 -304 29 -365 35 -60 6 -121 13 -134 16 l-24 5 6 -103z" />
      <path d="M14685 1795 c-111 -13 -384 -41 -485 -50 -30 -3 -122 -12 -205 -20
-455 -45 -1120 -100 -1615 -135 -162 -11 -347 -24 -410 -30 -63 -5 -200 -14
-305 -20 -104 -6 -260 -15 -345 -20 -85 -5 -228 -13 -317 -16 -151 -7 -163 -8
-163 -26 0 -46 36 -161 80 -253 202 -429 652 -657 1117 -566 195 38 344 116
491 255 166 158 256 338 286 572 l12 99 19 -55 c102 -307 366 -550 700 -643
102 -28 304 -34 429 -13 100 17 251 63 321 98 95 48 208 133 287 217 92 98
135 164 179 272 52 128 79 355 40 348 -3 -1 -55 -7 -116 -14z" />
    </g>
  </svg>
);

export default TentTopPath;
